export const quizTypes = {
  QUIZ: "QUIZ",
  CERTIFICATE: "CERTIFICATE",
};
